import React, { Component } from 'react';
import { Button, Icon, Label,Segment, Divider,Image,Popup,Input,Header,Dropdown, Form,Message } from 'semantic-ui-react';
import ReportContainer from '../../containers/report_container';
import {deleteImageFromReport,} from "../../data/report_api";
import { uploadTranscription} from "../../data/report_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";
import { formatTranscription } from '../../data/report_api';




const uuidv1 = require('uuid/v1');

class SpeechInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transcripts: [],
      continuous:false,
      showNotes:true,
      edit:undefined,
      editString:undefined,
      editingText:undefined,
      showImages:true,
      isMobile: window.innerWidth < 768,
      overFlowText:true,
      basicButtons:true,
      invertSegments:false,
      showMic:false,
      useAI:true,
      isListening:false,
      processingTranscript:false,
      addNewType:undefined,
      addThroughVoice:true,
      rgi:undefined,
      hideOnScroll: true,
      selectedVoiceModel:"gpt-4o-transcribe",
      useWebAudio: /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
    };
    this.mediaRecorder = null;
    this.chunks = [];

    //WEB AUDIO API VARS
    this.mediaStream = null;     // save the MediaStream so you can stop tracks later
    this.audioContext = null;    // save the AudioContext
    this.scriptNode = null;      // save ScriptProcessorNode
    this.sourceNode = null;      // save MediaStreamSource

    

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition) {

        this.recognition = new SpeechRecognition();
        this.recognition.continuous = this.state.continuous;
        this.recognition.interimResults = false;
        this.recognition.lang = 'en-UK';
        this.recognition.onstart = () => this.setState({ isListening: true });
        this.recognition.onend = () => this.setState({ isListening: false });
        this.recognition.onresult = this.handleResultSpeechRecognition;
    } else {
      alert('SpeechRecognition is not supported in this browser.');
    }
  }

 componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  
  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  };

    formatSpeechTranscription = async (transcription_text) => {
      let formData = new FormData()
      formData.append("transcription_text", transcription_text)
      formData.append("report_id", this.props.reportDetails["id"])
      formData.append("multi_item",true)
      let response = await formatTranscription(formData)
      if (response.success) {
        return(response.formattedText.trim().split("\n")) //split by newline)
      } else {
        return(["IN-ERROR WHILE TRANSCRIBING AUDIO, CHECK YOUR INTERNET CONNECTION OR TRY AGAIN LATER."])
      }
  }  

  addNewDataButtons= (r_i=undefined,g_i=undefined) => {
    if(this.props.other_template || this.props.reportDetails["inspection_type"] !== "co"){
   return  <div style={{textAlign:"center", width: "100%", margin:"auto",marginTop:"15px",marginBottom:"15px"}}>
{r_i==undefined && g_i==undefined && <Button basic={this.state.basicButtons} disabled={this.state.isListening} fluid icon size="large" circular color='green' 
onClick={()=>{ !this.state.addThroughVoice?this.addNewRoomAtLast(["NEW ROOM",""]):this.setState({addNewType:"room"},()=>{this.toggleListening()})}}
  ><Icon name="add"></Icon> Room</Button>}

{r_i != undefined && g_i == undefined && <Button basic={this.state.basicButtons} disabled={this.state.isListening}  fluid size="large" icon circular color='orange' onClick={()=>{ !this.state.addThroughVoice?this.addNewGroupAtLast(["NEW GROUP",""],r_i):this.setState({addNewType:"group",rgi:[r_i,undefined,undefined]},()=>{this.toggleListening()})}}><Icon name="add"></Icon> Group</Button>}


{ r_i != undefined && g_i != undefined && <div style={{display:"flex",gap:"10px",justifyContent:"center"}}>
  <Button basic={this.state.basicButtons} disabled={this.state.isListening} fluid size="large" circular  color='blue' onClick={()=>{ !this.state.addThroughVoice?this.addNewItemAtLast(["NEW ITEM",""],r_i,g_i):this.setState({addNewType:"item",rgi:[r_i,g_i,undefined]},()=>{this.toggleListening()})}}><Icon name="add"></Icon> Item {this.state.addThroughVoice && "(Single)"}</Button>
{this.state.addThroughVoice && <Button basic={this.state.basicButtons} disabled={this.state.isListening} fluid size="large" circular  color='blue' onClick={()=>{this.setState({addNewType:"item_multi",rgi:[r_i,g_i,undefined]},()=>{this.toggleListening()})}}><Icon name="add"></Icon>Item (Multi)</Button>}
  </div>}
        </div>}
        }
        

  handleResultSpeechRecognition = (event) => {
    for (let i = event.resultIndex; i < event.results.length; i++) {
      const result = event.results[i];
  
      if (result.isFinal) {
        let transcript = result[0].transcript.trim();
  
        if (transcript.length === 0) {
          // Ignore empty chunks
          continue;
        }
        this.processSpeechTranscript(transcript)
      }
    }
  };

  processSpeechTranscript = async (transcript) => {
            // Capitalize nicely
        let capTranscript = transcript.charAt(0).toUpperCase() + transcript.slice(1);
        capTranscript = capTranscript.replace(".","")
        if(this.state.addNewType) {
          let addNew = this.state.addNewType
            switch(addNew) {
            case "room":
              this.addNewRoomAtLast([capTranscript,""],)
            break;
            case "group":
              if(this.state.rgi) {
                this.addNewGroupAtLast([capTranscript,""],this.state.rgi[0])
              } else {
                this.addNewGroupAtLast([capTranscript,""],this.props.reportDetails.rooms.length - 1)
              }
            break;
            case "item":
              if(this.state.rgi) {
                  this.addNewItemAtLast([capTranscript,""],this.state.rgi[0],this.state.rgi[1] )
              } else {
                this.addNewItemAtLast([capTranscript,""],this.props.reportDetails.rooms.length - 1,this.props.reportDetails.rooms[this.props.reportDetails.rooms.length - 1].groups.length - 1)
              }
            break;
            case "item_multi":
              if(this.state.rgi) {
                let formattedItems = await this.formatSpeechTranscription(capTranscript)
                  formattedItems.map(line=>{
                    if(line.includes("IN-")) {
                      this.addNewItemAtLast([line.replace("IN-","").substring(0, 254),""],this.state.rgi[0],this.state.rgi[1] )
                    } else if(line.includes("IC-")) {
                      this.addNewItemConditionAtLast([line.replace("IC-",""),""],[this.state.rgi[0],this.state.rgi[1]])
                    }
                  
                  })
                } 
            break;
            case "transcript":
              this.setState({transcripts: [...this.state.transcripts, [capTranscript,uuidv1()]]})
            break;
            }
      }
  
      if(this.state.edit) {
          let edit = this.state.edit
          let obj = edit.obj
          switch(edit.type) {
            case "room":
              capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateRoomInReport(edit.roomIndex, obj);
              break;
            case "group":
              capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateGroupInReport(edit.roomIndex, edit.groupIndex, obj);
              break;
            case "item":
              capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
              break;   
              case "ci_notes":
                obj.ci_notes = capTranscript
                if (!obj.action) {
                  obj['action'] = 'update';
              }
                this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;  
                case "co_notes":
                obj.co_notes = capTranscript
                if (!obj.action) {
                  obj['action'] = 'update';
              }
                this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;  
          }
        } 
        this.setState({edit:undefined,isListening:false,processingTranscript:false, addNewType:undefined,rgi:undefined})
  }

  textEdit = (r_i,g_i,i_i,dataType,obj, co_flag=undefined) => {
    let edit = {client_id:obj.client_id,type:dataType,obj:obj,roomIndex:r_i,groupIndex:g_i,itemIndex:i_i}
          let capTranscript = this.state.editString
          switch(edit.type) {
            case "room":
               capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateRoomInReport(edit.roomIndex, obj);
              break;
            case "group":
              capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateGroupInReport(edit.roomIndex, edit.groupIndex, obj);
              break;
            case "item":
              capTranscript = capTranscript.slice(0, 254);
              obj.name = capTranscript
              if (!obj.action) {
                obj['action'] = 'update';
            }
              this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
              break;   
              case "ci_notes":
                obj.ci_notes = capTranscript
                if (!obj.action) {
                  obj['action'] = 'update';
              }
                this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;  
                case "co_notes":
                obj.co_notes = capTranscript
                if (!obj.action) {
                  obj['action'] = 'update';
              }
                this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;  
                case"co_flag":
                obj.flag = co_flag
                if (!obj.action) {
                  obj['action'] = 'update';
              }
                this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;

                case "co_flag_tenant_cost":
                  obj.tenant_cost_category = co_flag
                  if (!obj.action) {
                    obj['action'] = 'update';
                }
                  this.props.updateItemInReport(edit.roomIndex, edit.groupIndex, edit.itemIndex, obj);
                break;
          }
          this.setState({editString:undefined,editingText:undefined})

  };

  scrollToListenButton = () => {
    setTimeout(() => {
      const listenButton = document.getElementById("listen-button");
      if (listenButton) {
        listenButton.scrollIntoView({ block: "start" });
        window.scrollBy(0, -50); // scroll up by 50px
      }
    }, 100); // Adjust delay if needed
  };
  
  removeRoomImage = (r_i,file) => {
    this.props.removingFileSpeech(file)
                            if (file.id) { deleteImageFromReport(file.id).then((res) => {});}
                            this.props.removeMediaFromReport(r_i,-1,-1,file)
                          }

  removeItemImage = (r_i,g_i,i,file) =>{
    this.props.removingFileSpeech(file)
      if (file.id) {
            deleteImageFromReport(file.id).then((res) => {});}
            this.props.removeMediaFromReport(r_i,g_i,i,file)
          }

  addNewRoomAtLast = (transcript) => {
    if (transcript[0].length > 254) {transcript[0] = transcript[0].substring(0, 254);}
    if (this.props.reportDetails.id) {
        const addNewRoom = {
            client_id: uuidv1(),
            name: transcript[0],
            images: [],
            groups: [],
            additional_notes: "",
            action: 'create'
        };
        this.props.addNewRoomAtLast(addNewRoom);
        this.removeTranscript(transcript)
    }
};
addNewGroupAtLast = (transcript,r_i) => {
     if (transcript[0].length > 254) {transcript[0] = transcript[0].substring(0, 254);}
        const addNewGroup = {
            room_id: this.props.reportDetails.rooms[r_i].client_id,
            client_id: uuidv1(),
            name: transcript[0],
            images: [],
            items: [],
            action: 'create'
        };
        this.props.addNewGroupAtLast(r_i, addNewGroup);
        this.removeTranscript(transcript);
};
addNewItemAtLast = (transcript,r_i,g_i) => {
    if (transcript[0].length > 254) {transcript[0] = transcript[0].substring(0, 254);}
    let room =  this.props.reportDetails.rooms[r_i]
    let group_id =  room.groups[g_i].client_id

        const addNewItem = {
            group_id: group_id,
            client_id: uuidv1(),
            name: transcript[0],
            images: [],
            action: 'create',
            ci_notes: ""
        };
        this.props.addNewItemAtLast(r_i, g_i, addNewItem);
        this.removeTranscript(transcript);
};

    renderSpeechEditButton = (rgi, funcParams) => <Button style={{marginTop:"10px"}}  fluid
    //  loading={this.state.edit && this.state.edit.client_id === rgi.client_id} 
    disabled={this.state.processingTranscript}
     onClick={(()=>{this.speechEdit(...funcParams)})} circular  icon={!this.state.isListening? "microphone" : "stop"} 
     content={this.state.isListening ? this.state.processingTranscript ? "Processing Audio...":"Listening..." : "Edit With Audio"}/>

renderRoomView = (room,r_i) =>{
  //EDIT OPTIONS RENDER 
  let renderEditOptions =  () => {
    return     <div style={{textAlign:"center"}}><Label basic color="green">Room </Label><Header style={{marginTop:"10px"}}>{room.name}</Header>{(this.props.other_template || this.props.reportDetails["inspection_type"] !== "co") &&<div>  
    <Popup trigger={  <Button style={{marginTop:"10px"}} fluid circular disabled={this.state.isListening}  color="red" icon="close" content="Delete" />}
    content={<Button fluid negative content="Confirm Delete Room?" onClick={(e) => { this.props.deleteRoomFromReport(r_i);}}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
    
      {!this.state.editingText ? <Button style={{marginTop:"10px"}}  icon="edit" fluid circular onClick={()=>{this.setState({editString:room.name||"", editingText:true})}}content="Edit With Text"></Button>:<Segment style={{marginTop:"10px"}} ><Input autoFocus={true} onKeyDown={(e) => { if (e.key === 'Enter') {  e.target.blur();} }} onBlur={(e) => { this.textEdit(r_i, -1, -1, "room", room)}} style={{width:"60vw"}} size="mini" value={this.state.editString} onChange={e => this.setState({ editString: e.target.value })} placeholder="Edit text..." /></Segment>} </div>}
  {(this.props.other_template || this.props.reportDetails.inspection_type != "co") && this.renderSpeechEditButton(room,[r_i,-1,-1,"room",room])}
  <Button style={{marginTop:"10px"}} fluid disabled={!this.props.overlayImage || (this.props.overlayImage && this.props.overlayImage.loading)} loading={this.props.overlayImage && this.props.overlayImage.loading} onClick={(()=>{this.useOverlayImage(r_i,-1,-1,this.props.overlayImage)})}circular icon="camera" content="Add Overlay Image"/>
       </div>}

      //ROOM RENDER
  return   <React.Fragment><Segment inverted={this.state.invertSegments} color="green"
  style={{ position:"sticky",boxShadow:"none",top:this.state.isMobile ? 10:10+45,zIndex:100+r_i,marginTop: "10px", marginBottom:"0px", display: "flex", justifyContent: "space-between", alignItems: "center" }}  >
          <div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{ flex: 1 }}> 
          <Popup  hideOnScroll={this.state.hideOnScroll} on="click" style={{ display: "flex", gap: "5px", justifyContent:"space-between" }} wide="very"
          content={
          renderEditOptions()}
           trigger={<div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{cursor: 'pointer' }}> <Label  className={ this.state.invertSegments ? "inverted-green-label":""}basic={!this.state.invertSegments} color="green" horizontal>ROOM</Label><strong>{room.name}</strong> </div>}/> 
          </div>
</Segment>
{/* ----------------------------------------------------------ROOM IMAGES */}
{room.images.length > 0 && this.state.showImages && <Segment style={{display:"inline-block",marginBottom:"0px"}} attached="bottom"><Image.Group size="tiny" >{room.images.map(image => {
  let image_path = image.image_path || image.image && image.image.file.image_path ||image.image && image.image.file.dataURL
  return  <Popup key={image.id} trigger={<Image style={{borderRadius:"5px",  width:"auto", height:"100px",
  }} src={image_path || unavailable} />}
  content={<Button negative content="Confirm Delete Room Image??"  onClick={(e) => { this.removeRoomImage(r_i,image); }}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
  })}</Image.Group></Segment>}</React.Fragment>
}
renderGroupView = (room,group,r_i,g_i) =>{
  return <div style={{position:"sticky",top:this.state.isMobile ? 70:70+45,width:"99%", marginTop:"10px", marginLeft:"auto",zIndex:100+r_i}}>
           <Segment  inverted={this.state.invertSegments} color="orange" style={{ display: "flex", justifyContent: "space-between", alignItems: "center",marginBottom:"0px",boxShadow:"none" }}>
      <div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{ flex: 1, }}>
        <Popup  hideOnScroll={this.state.hideOnScroll} on="click" wide="very" 
            trigger={<div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{cursor:"pointer"}}><Label  className={ this.state.invertSegments ? "inverted-orange-label":""} basic={this.state.invertSegments? false:true} color="orange" horizontal>GROUP</Label><strong>{group.name}</strong></div>}
        content={
          <div style={{textAlign:"center"}}><Label basic color="orange">Group </Label><Header style={{marginTop:"10px"}}>{group.name}</Header> {(this.props.other_template || this.props.reportDetails["inspection_type"] !== "co") &&<div > 
      <Popup trigger={  <Button   disabled={this.state.isListening} style={{marginTop:"10px"}} circular fluid color="red" icon="close" content="Delete" />}
    content={<Button negative content="Confirm Delete Group?" onClick={(e) => {   this.props.deleteGroupFromReport(r_i,g_i,room.client_id);}}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
 {!this.state.editingText ? <Button style={{marginTop:"10px"}}  icon="edit" fluid circular onClick={()=>{this.setState({editString:group.name||"",editingText:true})}}content="Edit With Text"></Button>:<Segment style={{marginTop:"10px"}} ><Input onKeyDown={(e) => { if (e.key === 'Enter') {  e.target.blur();} }} autoFocus={true} onBlur={(e) => {this.textEdit(r_i, g_i, -1, "group", group) }} style={{width:"60vw"}} size="mini" value={this.state.editString} onChange={e => this.setState({ editString: e.target.value })} placeholder="Edit text..." /></Segment>} 
{this.renderSpeechEditButton(group,[r_i,g_i,-1,"group",group])}
           </div>}
          </div>} 
      /> 
      </div>
    </Segment>
  </div>
}
renderItemView = (item,r_i,g_i,i_i) => {
  let renderEditOptions =  () => {
    return     <div style={{textAlign:"center"}}><Label basic color="green">Item</Label><Header style={{marginTop:"10px"}}>{item.name}</Header>{(this.props.other_template || this.props.reportDetails["inspection_type"] !== "co") &&<div>  
    <Popup trigger={  <Button  disabled={this.state.isListening} style={{marginTop:"10px"}} fluid circular   color="red" icon="close" content="Delete" />}
    content={<Button fluid negative content="Confirm Delete Item?" onClick={(e) => { this.props.deleteItemFromReport(r_i,g_i,i_i);}}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
      {!this.state.editingText ? <Button style={{marginTop:"10px"}}  icon="edit" fluid circular onClick={()=>{this.setState({editString:item.name||"",editingText:true})}}content="Edit With Text"></Button>:<Segment style={{marginTop:"10px"}} ><Input onKeyDown={(e) => { if (e.key === 'Enter') {  e.target.blur();} }} autoFocus={true} onBlur={(e) => { this.textEdit(r_i, g_i, i_i, "item", item)}} style={{width:"60vw"}} size="mini" value={this.state.editString} onChange={e => this.setState({ editString: e.target.value })} placeholder="Edit text..." /></Segment>}
       </div>}
      {(this.props.other_template || this.props.reportDetails.inspection_type != "co") && this.renderSpeechEditButton(item,[r_i,g_i,i_i,"item",item])}
  <Button style={{marginTop:"10px"}} fluid disabled={!this.props.overlayImage || (this.props.overlayImage && this.props.overlayImage.loading)} loading={this.props.overlayImage && this.props.overlayImage.loading} onClick={(()=>{this.useOverlayImage(r_i,g_i,i_i,this.props.overlayImage)})}circular icon="camera" content="Add Overlay Image"/>
       </div>}

  return <React.Fragment key={item.client_id}>
         <div style={{width:"98%", marginLeft:"auto",marginTop:"10px"}}>
         <Segment  inverted={this.state.invertSegments} color="blue" style={{ display: "flex", justifyContent: "space-between", alignItems: "center",marginBottom:"0px" }}>
          <div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{ flex: 1,}}>

    <Popup  hideOnScroll={this.state.hideOnScroll} on="click" style={{ display: "flex", gap: "5px", justifyContent:"space-between" }} wide="very" 
    trigger={<div  className={this.state.overFlowText && "overflow-ellipses-speech"}style={{cursor:"pointer"}}><Label  className={ this.state.invertSegments ? "inverted-blue-label":""} basic={this.state.invertSegments? false:true} color="blue" horizontal>ITEM NAME</Label><strong>{item.name}</strong></div>}
     //content
    content={renderEditOptions()} 
    /> 
          </div>
</Segment>
 {//CI NOTES  ----------------------------------
 }
{this.state.showNotes && <Segment  secondary={this.state.invertSegments} style={{ marginTop:"0px",display: "flex", justifyContent: "space-between", alignItems: "center",marginBottom:"0px" }}>
  <div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{ flex: 1, }}>
 <Popup  hideOnScroll={this.state.hideOnScroll} on="click" style={{ display: "flex", gap: "5px", justifyContent:"space-between" }} wide="very" 
 trigger={    <div className={this.state.overFlowText && "overflow-ellipses-speech"}  style={{ cursor: 'pointer' }}><Label basic color='grey' horizontal>CI Note</Label><strong>{item.ci_notes}</strong></div>}
 
 content={<div style={{textAlign:"center"}}><Label basic color="grey">CI Notes</Label><Header style={{marginTop:"10px"}}>{item.ci_notes}</Header>{(this.props.other_template || this.props.reportDetails["inspection_type"] !== "co") && <div> 
      {!this.state.editingText ? <Button style={{marginTop:"10px"}}  icon="edit" fluid circular onClick={()=>{this.setState({editString:item.ci_notes || " ",editingText:true})}}content="Edit With Text"></Button>:<Segment style={{marginTop:"10px"}} ><Input onKeyDown={(e) => { if (e.key === 'Enter') {  e.target.blur();} }} autoFocus={true} onBlur={(e) => {  this.textEdit(r_i, g_i, i_i, "ci_notes", item)}} style={{width:"60vw"}} size="mini" value={this.state.editString} onChange={e => this.setState({ editString: e.target.value })} placeholder="Edit text..." /></Segment>}
      {this.renderSpeechEditButton(item,[r_i,g_i,i_i,"ci_notes",item])}
         </div>}
    </div>}
    /> 
  </div>

</Segment>}
 {//CO NOTES  ----------------------------------
 }
{this.props.reportDetails['inspection_type'] === 'co' && <Segment secondary={this.state.invertSegments}  style={{ marginTop:"0px",display: "flex", justifyContent: "space-between", alignItems: "center",marginBottom:"0px" }}>
  <div  className={this.state.overFlowText && "overflow-ellipses-speech"}style={{ flex: 1 }}>
 <Popup  hideOnScroll={this.state.hideOnScroll} on="click" style={{ display: "flex", gap: "5px", justifyContent:"space-between" }} wide="very" 
 
 content={<div className={this.state.overFlowText && "overflow-ellipses-speech"} style={{textAlign:"center"}}><Label basic color="grey">CO Notes</Label><Header style={{marginTop:"10px"}}>{item.co_notes}</Header><div> 
      {!this.state.editingText ? <Button style={{marginTop:"10px"}}  icon="edit" fluid circular onClick={()=>{this.setState({editString:item.co_notes || " ",editingText:true})}}content="Edit With Text"></Button>:<Segment style={{marginTop:"10px"}} ><Input onKeyDown={(e) => { if (e.key === 'Enter') {  e.target.blur();} }}  autoFocus={true} onBlur={(e) => {  this.textEdit(r_i, g_i, i_i, "co_notes", item)}} style={{width:"60vw"}} size="mini" value={this.state.editString} onChange={e => this.setState({ editString: e.target.value })} placeholder="Edit text..." /></Segment>}
      {this.renderSpeechEditButton(item,[r_i,g_i,i_i,"co_notes",item])}
         </div>
    </div>}
    
    trigger={<div style={{cursor:"pointer"}}>   <Label basic color='grey' horizontal>CO Note</Label><strong>{item.co_notes}</strong></div>}/> 
  </div>
  <div style={{ display: "flex", gap: "5px" }}>
  <Popup wide='very' position="top right" on="click" hideOnScroll trigger={<Button color="orange" circular icon="exclamation" compact basic={!this.state.invertSegments} size="mini" content={item.flag? `${item.flag} ${item.flag === "Tenant Cost" ? item.tenant_cost_category ? item.tenant_cost_category :"" : "" }` : "No Liability"}/>}
      content={ <div style={{width:"60vw",textAlign:"center"}}>
                                          <Header as="h4"> Assign Liability</Header>
                                                      <Button.Group vertical={this.state.isMobile ? true:false} size="small">
                                                  <Button primary={item.flag === "Tenant Cost" ? true:false}circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag",item,"Tenant Cost") }>Tenant Cost</Button>
                                                  <Button primary={item.flag === "Wear and Tear" ? true:false}circular size="mini" compact onClick={()=> this.textEdit(r_i,g_i,i_i,"co_flag",item,"Wear and Tear")}>Fair Wear and Tear</Button>
                                                  <Button primary={item.flag === "Landlord Info" ? true:false}circular size="mini" compact onClick={()=> this.textEdit(r_i,g_i,i_i,"co_flag",item, "Landlord Info")}>Landlord Information</Button>
                                              {this.props.other_template && <Button primary={item.flag === "Similar" ? true:false}circular size="mini" compact onClick={()=>{ this.textEdit(r_i,g_i,i_i,"co_flag",item,"Similar")}}>Similar to Check In</Button>}
                                              </Button.Group >
                                              <Divider></Divider>
                                              {item.flag === "Tenant Cost" && <div>
                                                <Header as="h5">Assign Tenant Cost Category</Header>
                                                <Button.Group size="small"   vertical={this.state.isMobile ? true:false}>
                                                <Button primary={item.tenant_cost_category === "DAMAGE" ? true:false}circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag_tenant_cost",item,"DAMAGE") }>DAMAGE</Button>
                                                <Button primary={item.tenant_cost_category === "CLEANING" ? true:false}circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag_tenant_cost",item,"CLEANING") }>CLEANING</Button>
                                                <Button primary={item.tenant_cost_category === "REDECORATION" ? true:false}circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag_tenant_cost",item,"REDECORATION") }>REDECORATION</Button>
                                                <Button primary={item.tenant_cost_category === "GARDENING" ? true:false} circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag_tenant_cost",item,"GARDENING") }>GARDENING</Button>
                                                <Button primary={item.tenant_cost_category === "OTHER" ? true:false}circular size="mini" compact onClick={()=>this.textEdit(r_i,g_i,i_i,"co_flag_tenant_cost",item,"OTHER") }>OTHER</Button>
                                                </Button.Group>
                                                </div>}
                
                                              </div>}
      />
  </div>
</Segment>}

{/* Images Section - Will appear below the name and button */}
{item.images.length > 0 && this.state.showImages && (
  <Segment secondary style={{ display: "inline-block", marginBottom: "0px"  }} attached="bottom">
    <Image.Group size="tiny">
      {item.images.map(image => {
        let image_path = image.image_path || image.image && image.image.file.image_path || image.image && image.image.file.dataURL;
        return<Popup key={image.id} trigger={<Image style={{borderRadius:"5px",  width:"auto", height:"100px",
        }} src={image_path|| unavailable} />}
        content={<Button negative content="Confirm Delete Item Image??"  onClick={(e) => {
                                                                            this.removeItemImage(r_i,g_i,i_i,image);
                                                                        }}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
      })}
    </Image.Group>
  </Segment>
)}


    </div>
      </React.Fragment>
}
addNewItemConditionAtLast = (transcript,r_g_i = undefined) => {

  let room =  this.props.reportDetails.rooms[ this.props.reportDetails.rooms.length - 1]
  let group = room.groups[room.groups.length - 1]
  let item = group.items[group.items.length - 1]

  if(r_g_i !== undefined) {
    room =  this.props.reportDetails.rooms[ r_g_i[0]]
    group = room.groups[r_g_i[1]]
    item = group.items[group.items.length - 1]
  }
    if (!item.action) {
        item['action'] = 'update';
    }

    if(this.props.reportDetails['inspection_type'] === 'co' && this.props.other_template){
      item["co_notes"] = `${item["co_notes"] ? item["co_notes"] : ""}${(!item["co_notes"] || item["co_notes"].trim() === "")?"":","}${transcript[0]}`
    } else {
      item["ci_notes"] = `${item["ci_notes"] ? item["ci_notes"] : ""}${(!item["ci_notes"] || item["ci_notes"].trim() === "")?"":","}${transcript[0]}`
    }
    this.props.updateItemInReport(this.props.reportDetails.rooms.length - 1, room.groups.length - 1,group.items.length - 1, item);
      this.removeTranscript(transcript);
};

speechEdit = (r_i,g_i,i_i,dataType,obj) => {
  if(this.state.isListening == false )
  {
    this.setState({isListening:true,edit:{client_id:obj.client_id,type:dataType,obj:obj,roomIndex:r_i,groupIndex:g_i,itemIndex:i_i}})
  }
  this.toggleListening()
}

toggleListening = () =>{
  if(this.state.useAI) {
    if(!this.state.isListening) {
      if(!this.state.useWebAudio) {
        this.startRecording()
      }
      else {
      this.startWAVRecording()
      }
    }
    else {
      if(!this.state.useWebAudio) { 
        this.stopRecording()
      } else {
        this.stopWAVRecording()
      }
    }
  } else {
    if (this.recognition && !this.state.isListening) {
      this.recognition.start();
    } else{
      this.recognition.stop();
    }
  } 
}

// WAV RECORDING SECITON ------------------------------------------------------------------
startWAVRecording = async () => {
  this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
  this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
  this.sourceNode = this.audioContext.createMediaStreamSource(this.mediaStream);
  this.scriptNode = this.audioContext.createScriptProcessor(4096, 1, 1);

  this.chunks = [];

  this.scriptNode.onaudioprocess = (e) => {
    const data = e.inputBuffer.getChannelData(0);
    this.chunks.push(new Float32Array(data));
  };

  this.sourceNode.connect(this.scriptNode);
  this.scriptNode.connect(this.audioContext.destination);

  this.setState({ isListening: true });
};

stopWAVRecording = () => {
  this.scriptNode.disconnect();
  this.sourceNode.disconnect();
  this.mediaStream.getTracks().forEach(track => track.stop());

  const wavBlob = this.createWavBlob(this.chunks, this.audioContext.sampleRate);
  this.setState({processingTranscript:true})
  this.transcribeAudio(wavBlob)
  this.audioContext.close();

  // Clean up
  this.audioContext = null;
  this.mediaStream = null;
  this.sourceNode = null;
  this.scriptNode = null;
  this.chunks = [];

};

 createWavBlob = (chunks, sampleRate)  =>{
  const floatData = this.flattenChunks(chunks);
  const buffer = new ArrayBuffer(44 + floatData.length * 2);
  const view = new DataView(buffer);

  // WAV header
  this.writeString(view, 0, 'RIFF');
  view.setUint32(4, 36 + floatData.length * 2, true);
  this.writeString(view, 8, 'WAVE');
  this.writeString(view, 12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);  // PCM
  view.setUint16(22, 1, true);  // mono
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2, true);  // byte rate
  view.setUint16(32, 2, true);  // block align
  view.setUint16(34, 16, true); // bits per sample
  this.writeString(view, 36, 'data');
  view.setUint32(40, floatData.length * 2, true);

  // PCM samples
  let offset = 44;
  for (let i = 0; i < floatData.length; i++, offset += 2) {
    let s = Math.max(-1, Math.min(1, floatData[i]));
    view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }

  return new Blob([view], { type: 'audio/wav' });
}

flattenChunks = (chunks) => {
  const len = chunks.reduce((acc, c) => acc + c.length, 0);
  const result = new Float32Array(len);
  let offset = 0;
  chunks.forEach(chunk => {
    result.set(chunk, offset);
    offset += chunk.length;
  });
  return result;
}

writeString = (view, offset, str) => {
  for (let i = 0; i < str.length; i++) {
    view.setUint8(offset + i, str.charCodeAt(i));
  }
}
// END WAV RECORDING SECITON ------------------------------------------------------------------


 startRecording = async () => {
  this.setState({isListening:true})
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      window.alert( 'getUserMedia not supported in this browser.');
      this.setState({isListening:false})
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.chunks = [];
      this.mediaRecorder = new MediaRecorder(stream);

      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        this.setState({processingTranscript:true})
        const blob = new Blob(this.chunks, { type: 'audio/webm' });
        // const audioURL = URL.createObjectURL(blob);
        this.transcribeAudio(blob)
      };

      this.mediaRecorder.start();
    } catch (error) {
                  switch (error.name) {
                case 'AbortError': //error from navigator.mediaDevices.getUserMedia
                    window.alert("An AbortError has occured.");
                    break;
                case 'NotAllowedError': //error from navigator.mediaDevices.getUserMedia
                    window.alert("A NotAllowedError has occured. User might have denied permission.");
                    break;
                case 'NotFoundError': //error from navigator.mediaDevices.getUserMedia
                    window.alert("GetUserMedia: A NotFoundError has occured.");
                    break;
                case 'NotReadableError': //error from navigator.mediaDevices.getUserMedia
                    window.alert("GetUserMedia: A NotReadableError has occured.");
                    break;
                case 'SecurityError': //error from navigator.mediaDevices.getUserMedia or from the MediaRecorder.start
                    window.alert("A SecurityError has occured.");
                    break;
                case 'TypeError': //error from navigator.mediaDevices.getUserMedia
                    window.alert("Get UserMedia: A TypeError has occured.");
                    break;
                case 'InvalidStateError': //error from the MediaRecorder.start
                    window.alert("MediaRecorder: An InvalidStateError has occured.");
                    break;
                case 'UnknownError': //error from the MediaRecorder.start
                    window.alert("MediaRecorder: An UnknownError has occured.");
                    break;
                default:
                    window.alert("An error occured with the error name " + error.name);
            };
  
      this.setState({isListening:false,edit:undefined,isListening:false,processingTranscript:false, addNewType:undefined,rgi:undefined });
    }
  };

  stopRecording = () => {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
  };
  transcribeAudio = async (audioBlob) => {
          let formData = new FormData()
           const mimeType = audioBlob.type; 
            let fileExtension = "webm"
            const mimeParts = mimeType.split('/');
            if (mimeParts.length > 1) {
              fileExtension = mimeParts[1].split(';')[0];
            }
            console.log(fileExtension)

  // 3. Construct the filename dynamically
  const fileName = `audio.${fileExtension}`;

  // 4. Append the file with the correct name and type
  formData.append("file", audioBlob, fileName);
          formData.append("model", this.state.selectedVoiceModel);
          // formData.append("report_id", this.props.reportDetails["id"])
          let response = await uploadTranscription(formData)
          if (response.success) {
            this.processSpeechTranscript(response.transcriptionText)
          } else {
            this.processSpeechTranscript(` ERROR WHILE TRANSCRIBING AUDIO, CHECK YOUR INTERNET CONNECTION OR TRY AGAIN LATER. Error - ${response.statusMessage} Extension: ${fileExtension}`)
          }
      }
useOverlayImage = (r_i,g_i,i_i,fileData) => {
  const url = fileData.file;
  const extension = url.split('.').pop().split('?')[0].toLowerCase();

  let mimeType = 'image/jpeg'; // default
  if (extension === 'png') mimeType = 'image/png';
  if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';

  const filename = `${fileData.id}.${extension}`;
  const client_id = uuidv1();


    const dummyBlob = new Blob([""], { type: "image/png" });
    const dummyFile = new File([dummyBlob],filename, {
        type: "image/png",
    });
    dummyFile.dataURL = url
  let imageObj = {
    additionalImgId:fileData.id,
    id:client_id,
    file: dummyFile,
    image_path: url,
};
this.props.addNewMediaIntoReport(r_i, g_i, i_i, imageObj);

this.nextOverlayImage(1);
};

  playCameraClick = () => {
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const oscHigh = context.createOscillator();
    const gainHigh = context.createGain();
  
    // High "click" part
    oscHigh.type = "square";
    oscHigh.frequency.setValueAtTime(1000, context.currentTime);
    gainHigh.gain.setValueAtTime(0.05, context.currentTime);
    oscHigh.connect(gainHigh).connect(context.destination);
    oscHigh.start();
    oscHigh.stop(context.currentTime + 0.04); // ⏱️ doubled to 80ms
  };

nextOverlayImage = (stepAmount = 1) =>{
  this.playCameraClick();
  const index = this.props.overlayImageList.findIndex(img => img.id === this.props.overlayImage.id);
  if (index !== -1 && (index + stepAmount < this.props.overlayImageList.length - 1)) {
      this.props.setSelectedOverlayImage(this.props.overlayImageList[index + stepAmount]);
  }
  else { this.props.setSelectedOverlayImage(this.props.overlayImageList[this.props.overlayImageList.length - 1]);}
}
removeTranscript = (transcript) => {
  const transcriptId = transcript[1];

  this.setState((prevState) => ({
    transcripts: prevState.transcripts.filter(t => t[1] !== transcriptId)
  }));
};
  render() {
            let voiceModelOptions = [
        {key: 1, text: "GPT4o Transcribe (Slower, More Powerful)", value: "gpt-4o-transcribe"},
        {key: 2, text: "GPT4o Mini Transcribe (Faster, Less Accurate)", value: "gpt-4o-mini-transcribe"},
        {key: 3, text: "Whisper (Old Model)", value: "whisper-1"},
    ];
    let rooms = this.props.reportDetails.rooms || [];
    let lastRoom = rooms.length > 0 ? rooms[rooms.length - 1] : null;
    let hasGroupsInLastRoom = lastRoom && lastRoom.groups && lastRoom.groups.length > 0;
    let hasItemsInLastGroup = lastRoom && lastRoom.groups && lastRoom.groups.length > 0 && lastRoom.groups[lastRoom.groups.length - 1].items && lastRoom.groups[lastRoom.groups.length - 1].items.length > 0;
    return (
<React.Fragment>
  <div className="report-container-responsive"style={{  
    boxSizing: 'border-box', 
    margin: 'auto'
    }} >
    <div style={{ textAlign:"center", width: "100%", margin:"auto", marginBottom:"1rem" }}>
    <Message><Message.Header>Important - Please watch tutorial before attempting</Message.Header>Speech Input is meant to be combined with the live camera feature of the image overlay to complete reports quickly on your phone while at the property, saving you time typing at home. Please ensure you have seen the tutorial before attempting: <a href="https://youtu.be/uB46WWL4f2M">https://youtu.be/uB46WWL4f2M</a></Message>
        { !this.props.overlayImageList && <Button onClick={() => { const overlayButton = document.getElementById('show_overlay_button'); if (overlayButton) { overlayButton.click(); } else { console.warn('Button with ID "show_overlay_button" not found.'); }}}><Icon name="photo"></Icon>Show Photo Overlay</Button>}
        <Popup className={"responsive-wide-popup"}hideOnScroll wide="very" on="click" trigger={<Button primary icon><Icon name="settings" />Options</Button>}
        content={
                <div className="bottom-margin" style={{textAlign:"center"}}>
                <Header>Options</Header>
                <Form.Field> <label>AI Voice Model Selection</label> <Dropdown placeholder="Select Voice Model" fluid selection options={voiceModelOptions} onChange={(e, { value }) => this.setState({ selectedVoiceModel: value })} value={this.state.selectedVoiceModel} /> </Form.Field>
                <Divider/>
                    {this.props.other_template && <Button basic  color={this.state.showNotes?"blue":"grey"}fluid onClick={()=>this.setState({showNotes:!this.state.showNotes},()=>this.scrollToListenButton())}>Show CI Notes: {this.state.showNotes ? "ON" : "OFF"}</Button>}
                  <Button basic icon color={this.state.showImages?"blue":"grey"} fluid onClick={()=>this.setState({showImages:!this.state.showImages},()=>this.scrollToListenButton())}>Show Images: {this.state.showImages ? "ON" : "OFF"}</Button>
                  <Button basic icon color={this.state.invertSegments?"blue":"grey"} fluid onClick={()=>this.setState({invertSegments:!this.state.invertSegments})}>Full Color Headers: {this.state.invertSegments ? "ON" : "OFF"}</Button>
                    {(this.props.reportDetails.inspection_type != "co" || this.props.other_template) && <Button basic icon color={!this.state.basicButtons?"blue":"grey"} fluid onClick={()=>this.setState({basicButtons:!this.state.basicButtons})}>Full Color Add Buttons: {this.state.basicButtons ? "OFF" : "ON"}</Button>}
                        <Button basic color={!this.state.overFlowText?"blue":"grey"}fluid onClick={()=>this.setState({overFlowText:!this.state.overFlowText},()=>this.scrollToListenButton())}>{this.state.overFlowText ? "Word Wrap: Off" : "Word Wrap: On"}</Button>
                      {/* { (this.props.reportDetails['inspection_type'] !== 'co' || (this.props.reportDetails['inspection_type'] === 'co' && this.props.other_template)) && <Button basic color={this.state.showMic?"blue":"grey"}fluid onClick={()=>this.setState({showMic:!this.state.showMic},()=>this.scrollToListenButton())}>{this.state.showMic ? "Show Mic: On" : "Show Mic: Off"}</Button>} */}
                    <Button basic icon color={this.state.useAI?"blue":"grey"} fluid onClick={()=>this.setState({useAI:!this.state.useAI})}>Recognition Type:{this.state.useAI ? "AI" : "Browser"}</Button>
                    <Button basic icon color={this.state.hideOnScroll?"blue":"grey"} fluid onClick={()=>this.setState({hideOnScroll:!this.state.hideOnScroll})}>Hide Popups on Scroll:{this.state.hideOnScroll ? "ON" : "OFF"}</Button>
                    <Button basic icon disabled={this.state.isListening} color={this.state.useWebAudio?"blue":"grey"} fluid onClick={()=>this.setState({useWebAudio:!this.state.useWebAudio})}>IOS Audio Recording Mode (Slower):{this.state.useWebAudio ? "ON" : "OFF"}</Button>
                  {(this.props.reportDetails.inspection_type != "co" || this.props.other_template) &&   <Button basic icon color={this.state.addThroughVoice?"blue":"grey"} fluid onClick={()=>this.setState({addThroughVoice:!this.state.addThroughVoice})}>Listen on Add New: {this.state.addThroughVoice ? "ON" : "OFF"}</Button>}
                            </div>}>
            </Popup>
    </div>
    <Divider/>
   {rooms.map((room,r_i) =>{
    // --------------------------------------------------------------ROOMS LOOP
return   <React.Fragment  key={room.client_id}>
   {this.renderRoomView(room,r_i)}     
  {room.groups.map((group,g_i) => {
    // -----------------------------------------------------GROUPS LOOP
    return  <React.Fragment  key={group.client_id}>
      {this.renderGroupView(room,group,r_i,g_i)}
    {group.items.map((item,i_i )=> {
      // ----------------------------------------------------------------------------ITEMS LOOP
      return this.renderItemView(item,r_i,g_i,i_i)
    })}{ this.addNewDataButtons(r_i,g_i)}
    </React.Fragment>
  })} { this.addNewDataButtons(r_i)}
        </React.Fragment>
   })}
  {this.addNewDataButtons()}
<Divider></Divider>
  </div>

                    {//STICKY BUTTON WHEN RECORDING IS ON - TOP BUTTON
                    this.state.isListening && <Button size="massive" circular icon loading={this.state.processingTranscript} disabled={this.state.processingTranscript}   
                     className={this.state.processingTranscript ? "glow-shadow-red" :"glow-shadow-green"}
                    style={{backgroundColor:"white", opacity:1,position: 'fixed', top: '40px', left: '50%', transform: 'translateX(-50%)', zIndex: 1901, }}
                    onClick={()=>{ this.toggleListening()}}><Icon name={this.state.isListening ? "stop" : "microphone"}></Icon> Listening...</Button>
                    }

                    {
                      this.state.isListening && !this.props.overlayImageList && <Button size="massive" circular icon loading={this.state.processingTranscript} disabled={this.state.processingTranscript}   
                     className={this.state.processingTranscript ? "glow-shadow-red" :"glow-shadow-green"}
                    style={{backgroundColor:"white", opacity:1,position: 'fixed', bottom: '40px', left: '50%', transform: 'translateX(-50%)', zIndex: 1901, }}
                    onClick={()=>{ this.toggleListening()}}><Icon name={this.state.isListening ? "stop" : "microphone"}></Icon> Listening...</Button>
                    }

{// OLD MIC BUTTON
/* {
(this.props.reportDetails['inspection_type'] !== 'co' || (this.props.reportDetails['inspection_type'] === 'co' && this.props.other_template) ) && this.state.showMic && <div style={{ textAlign:"center", width: "100%", margin:"auto", marginBottom:"1rem" }}>
    <h3>{this.state.isListening ? this.state.processingTranscript ? "Processing Audio...":"Listening..." : "Press to start listening"}</h3>
    <Button id="listen-button" size="massive" circular icon loading={this.state.processingTranscript} disabled={this.state.processingTranscript}  primary onClick={()=>this.setState({addNewType:"transcript"},()=>{ this.toggleListening()})}><Icon name={this.state.isListening ? "stop" : "microphone"}></Icon></Button>
    <p/></div>
    } */}
            <Divider></Divider>
      {this.state.transcripts.map((transcript) => (<div key={transcript[1]} style={{textAlign:"center", width: "100%", margin:"auto", marginBottom:"1rem"}}>
    <Button size="big" attached='top'>{transcript[0]}</Button> 
            <Segment attached="bottom">
        <Button size="large" circular color='green' onClick={()=> {this.addNewRoomAtLast(transcript);        this.scrollToListenButton();}}>R</Button>
        <Button size="large" disabled={!lastRoom}style={{backgroundColor:"#f2711c"}}circular color='orange' onClick={()=> {this.addNewGroupAtLast(transcript,this.props.reportDetails.rooms.length - 1);        this.scrollToListenButton();}}>G</Button>
        <Button size="large" disabled={!hasGroupsInLastRoom} circular  color='blue' onClick={()=>{ this.addNewItemAtLast(transcript, this.props.reportDetails.rooms.length - 1, lastRoom.groups.length - 1);        this.scrollToListenButton();}}>I</Button>
        <Button size="large" disabled={!hasItemsInLastGroup} circular color='grey' onClick={()=> this.addNewItemConditionAtLast(transcript)}>IC</Button>
        <Button  size="large" circular  icon color='red' onClick={()=> this.removeTranscript(transcript)}><Icon name="close"></Icon></Button>
        </Segment>
        </div>))}
</React.Fragment>
    );
  }
}

export default ReportContainer(SpeechInput)



// WEBPACK FOOTER //
// ./src/views/report/speech_input.js